import { render, staticRenderFns } from "./YouthPartners.vue?vue&type=template&id=66d6e19d"
import script from "./YouthPartners.vue?vue&type=script&lang=js"
export * from "./YouthPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports